import * as ActionTypes from './actionTypes';

export const actionCreateGift = (payload) => ({
  payload,
  type: ActionTypes.CREATE_GIFT,
});

export const actionCreateGiftSuccess = (payload) => ({
  payload,
  type: ActionTypes.CREATE_GIFT_SUCCESS,
});

export const actionCreateGiftFailed = (payload) => ({
  payload,
  type: ActionTypes.CREATE_GIFT_FAILED,
});

// GET DETAILS
export const actionGetGiftDetails = (payload) => ({
  payload,
  type: ActionTypes.GET_GIFT_DETAILS,
});

export const actionGetGiftDetailsSuccess = (payload) => ({
  payload,
  type: ActionTypes.GET_GIFT_DETAILS_SUCCESS,
});

export const actionGetGiftDetailsFailed = (payload) => ({
  payload,
  type: ActionTypes.GET_GIFT_DETAILS_FAILED,
});

// UPDATE
export const actionUpdateGift = (payload) => ({
  payload,
  type: ActionTypes.UPDATE_GIFT,
});

export const actionUpdateGiftSuccess = (payload) => ({
  payload,
  type: ActionTypes.UPDATE_GIFT_SUCCESS,
});

export const actionUpdateGiftFailed = (payload) => ({
  payload,
  type: ActionTypes.UPDATE_GIFT_FAILED,
});

// DELETE
export const actionDeleteGift = (payload) => ({
  payload,
  type: ActionTypes.DELETE_GIFT,
});

export const actionDeleteGiftSuccess = (payload) => ({
  payload,
  type: ActionTypes.DELETE_GIFT_SUCCESS,
});

export const actionDeleteGiftFailed = (payload) => ({
  payload,
  type: ActionTypes.DELETE_GIFT_FAILED,
});

// GET GIFTS
export const actionGetGifts = (payload) => ({
  payload,
  type: ActionTypes.GET_GIFTS,
});

export const actionGetGiftsSuccess = (payload) => ({
  payload,
  type: ActionTypes.GET_GIFTS_SUCCESS,
});

export const actionGetGiftsFailed = (payload) => ({
  payload,
  type: ActionTypes.GET_GIFTS_FAILED,
});

// GET USER GIFTS
export const actionGetUserGifts = (payload) => ({
  payload,
  type: ActionTypes.GET_USER_GIFTS,
});

export const actionGetUserGiftsSuccess = (payload) => ({
  payload,
  type: ActionTypes.GET_USER_GIFTS_SUCCESS,
});

export const actionGetUserGiftsFailed = (payload) => ({
  payload,
  type: ActionTypes.GET_USER_GIFTS_FAILED,
});
